export function throwWhenTimeout(ms: number, error: () => Error): Promise<never> {
  return new Promise((_, reject) => {
    setTimeout(() => reject(error()), ms);
  });
}
